module.exports = __webpack_public_path__ + "img/partner5.fd07eda0.png";